import { useEffect, useRef } from "react";

export const CursorTrail = () => {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  useEffect(() => {
    if (window.matchMedia("(pointer: coarse)").matches) return;
    let mx = 0, my = 0, rx = 0, ry = 0;
    const move = (e) => { mx = e.clientX; my = e.clientY; if (dotRef.current) { dotRef.current.style.transform = `translate3d(${mx}px, ${my}px, 0)`; } };
    const loop = () => { rx += (mx - rx) * 0.14; ry += (my - ry) * 0.14; if (ringRef.current) ringRef.current.style.transform = `translate3d(${rx}px, ${ry}px, 0)`; requestAnimationFrame(loop); };
    window.addEventListener("mousemove", move);
    const raf = requestAnimationFrame(loop);
    const grow = () => ringRef.current && ringRef.current.classList.add("grow");
    const shrink = () => ringRef.current && ringRef.current.classList.remove("grow");
    document.querySelectorAll("a,button,.btn").forEach((el) => { el.addEventListener("mouseenter", grow); el.addEventListener("mouseleave", shrink); });
    return () => { window.removeEventListener("mousemove", move); cancelAnimationFrame(raf); };
  }, []);
  return (
    <>
      <div ref={dotRef} className="cursor-dot" aria-hidden="true" />
      <div ref={ringRef} className="cursor-ring" aria-hidden="true" />
    </>
  );
};
